import { render, staticRenderFns } from "./LifePage3.vue?vue&type=template&id=c5de926e&scoped=true"
import script from "./LifePage3.vue?vue&type=script&lang=js"
export * from "./LifePage3.vue?vue&type=script&lang=js"
import style0 from "./LifePage3.vue?vue&type=style&index=0&id=c5de926e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5de926e",
  null
  
)

export default component.exports